export function BetaStrip() {
  return (
    <div className="bg-ink text-paper px-4 sm:px-8 py-2 flex items-center gap-3 text-xs flex-wrap">
      <span className="font-mono text-[10px] tracking-[0.14em] text-signal-red">
        ● PUBLIC BETA
      </span>
      <span>
        Free for all teams during beta.{" "}
        <span className="font-serif italic opacity-85">
          Your feedback writes the roadmap.
        </span>
      </span>
    </div>
  );
}
